import { useNavigate } from "react-router-dom";
import { ccLogo } from "../../assets/data/Assests";
import { initiateAppleLogin } from "../../services/appleAuth";

// Backend redirects here on Apple OAuth failure:
// /auth/apple/error?message=...&code=...
export default function AppleAuthError() {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const message = params.get("message") || "Sign in with Apple failed. Please try again.";

    return (
        <div className="h-full w-full flex flex-col items-center justify-center bg-white dark:bg-[#1E1D21] px-6">
            <img alt="logo" src={ccLogo} className="h-16 w-16 mb-6" />
            <p className="text-[16px] font-bold text-red-500 mb-2 text-center">Sign in Failed</p>
            <p className="text-[13px] text-gray-600 dark:text-gray-300 text-center mb-6">
                {message}
            </p>
            <button
                onClick={() => initiateAppleLogin()}
                className="w-full max-w-xs h-12 rounded-xl bg-black text-white font-semibold text-[14px] mb-3 hover:bg-gray-900 transition-colors"
            >
                Try Again
            </button>
            <button
                onClick={() => navigate("/login", { replace: true })}
                className="w-full max-w-xs h-12 rounded-xl bg-[#BDE6FF] text-gray-900 font-semibold text-[14px]"
            >
                Back to Login
            </button>
        </div>
    );
}
